import "./index.scss"
import { Helmet } from "react-helmet";
import { useEffect, useState } from "react";
import CDNImage from "@/components/cdnImage/cdnImage";
import HeaderFooterWrapper from "@/components/headerFooterWrapper";
import { PAGE_TYPE } from "@/common-components-src/js/server";
import UKPageLoading from "@/common-components-src/components/UKPageLoading";

import { fetchEmailUnsubscribe } from "@/app/csr-src/apis/profile/profile.api";

const EmailUnsubscribe = () => {

  const [isLoading, setIsLoading] = useState(true);
  const [isSuccess, setIsSuccess] = useState(false);
  const [helmetTitle, setHelmetTitle] = useState("Unsubscribe | Joybuy");
  const unsubscribeUrl = "https://st.joy-sourcing.com/website/home/Group%206286861.png"
  
  useEffect(() => {
    requestUnsubscribe();
  }, []);

  const requestUnsubscribe = async () => {
    const url = new URL(window.location.href);
    const token = url.searchParams.get("token") || "";
    const res = await fetchEmailUnsubscribe(token);
    const success = res && res.data && res.code === "200";
    setIsLoading(false);
    setIsSuccess(success);
    setHelmetTitle(success ? "Unsubscribe Success | Joybuy" : "Unsubscribe | Joybuy");
  };

  function PageSuccess(){
    return <>
      <div className="title">Unsubscribed</div>
      <div className="desc">You have successfully unsubscribed from our emails.</div>
      <button onClick={()=>location.href="/"}>Keep shopping</button>
    </>
  }
  
  function PageUnsuccess(){
    return <>
      <div className="title">Oops! Something went wrong.</div>
      <div className="desc">We&apos;re working on resolving the issue. Please check back later.</div>
      <button onClick={()=>location.reload()}>Refresh</button>
    </>
  }
  
  if (isLoading) {
    return <UKPageLoading />;
  }
  
  return (
    <HeaderFooterWrapper pageType={PAGE_TYPE.UNSUBSCRIBE}>
      <Helmet>
          <title>{helmetTitle}</title>
          <meta
            name="description"
            content="Joybuy offers the best online shopping experience with free shipping and delivery guarantee on all orders. Shop now for unbeatable deals on top-quality products."
          />
      </Helmet>
      <div className="unsubscribe">
        <div className="frame">
          <CDNImage src={unsubscribeUrl} width={200} height={200} alt="unsubscribe" />
          { isSuccess ? <PageSuccess/> : <PageUnsuccess/> }
        </div>
      </div>
    </HeaderFooterWrapper>
  )
};

export default EmailUnsubscribe;
